// extracted by mini-css-extract-plugin
module.exports = {"info":"_3aa954e","type":"_9f8699d","typeInfo":"_be559e1","typeConfirmation":"_9281b1c","typeError":"_bd07498","typeWarning":"_fb804aa"};